
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-produits/nos-fauteuils/comparer",
      function () {
        return require("private-next-pages/nos-produits/nos-fauteuils/comparer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-produits/nos-fauteuils/comparer"])
      });
    }
  